import { CityRO } from '@routellers/types/dist/city/city.ro';

import { ApiMethodDeclaration } from '..';

/** ID city */
type ParamsData = number;

type ResponseData = CityRO;

export const remove: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/cities/${id}`,
    method: 'DELETE',
});
